import { Option } from '../../../multi-selector/multi-selector';

function uniqueByValue<T extends { value: string }>(items: T[] = []): T[] {
  const encounteredValues = new Set<string>();

  return items.filter((item) => {
    const currentValue = item.value;

    if (encounteredValues.has(currentValue)) {
      return false;
    }

    encounteredValues.add(currentValue);
    return true;
  });
}

export function castingArrayNumber(options: Option[] = []): {
  label: string;
  value: string;
}[] {
  const sanitizedOptions = options.map(({ value }) => {
    const castingNumber = String(value).replace(/[^0-9]/g, '');
    return {
      label: castingNumber,
      value: castingNumber,
    };
  });

  return uniqueByValue(sanitizedOptions);
}
